import agent_attorney from "./agent_attorney";
import agent_attorney_individs from "./agent_attorney_individs";
import employer from "./employer";
import employer_pocs from "./employer_pocs";
import foreign_labor, {
  ForeignLaborsQuery as foreign_labors,
} from "./foreign_labor";
import crop, { CropsQuery as crops } from "./crop";
import worker_housing, {
  WorkerHousingsQuery as worker_housings,
} from "./worker_housing";
import agriculture, { AgriculturesQuery as agricultures } from "./agriculture";
import material_terms, {
  MaterialTermssQuery as material_termss,
} from "./material_terms";
import foreign_worker from "./foreign_worker";
import foreign_worker_group from "./foreign_worker_group";

const ViewEntityQueryResolver = (tableName, id, groupId) => {
  const viewEntityQueryList = {
    "agent-attorney": agent_attorney(id),
    "agent-attorney-individs": agent_attorney_individs(id),
    employer: employer(id),
    "employer-pocs": employer_pocs(id),
    "foreign-labor": foreign_labor(id),
    "foreign-labors": foreign_labors(id),
    crop: crop(id),
    crops: crops(id),
    "worker-housing": worker_housing(id),
    "worker-housings": worker_housings(id),
    agriculture: agriculture(id),
    agricultures: agricultures(id),
    "material-terms": material_terms(id),
    "foreign-worker": foreign_worker(id),
    "material-termss": material_termss(id),
    "foreign-worker-group": foreign_worker_group(id, groupId),
  };
  return viewEntityQueryList[tableName];
};

export default ViewEntityQueryResolver;
